<template>
  <div class="ic-form__r-07">
    <FormWrapper :validator="$v.form">
      <IcFormRowWrapper
        id="caseNo"
        name="caseNo"
        :labelWidth="4"
        :controlWidth="8"
        :label="$t('label_complaint_case_no')"
      >
        <template slot-scope="{validator}">
          <IcInput id="caseNo" v-model="form.caseNo" @input="emitInput(form.caseNo,validator)" />
        </template>
      </IcFormRowWrapper>
      <IcFormContactName v-model="form.name" />
      <IcFormContactEmail
        v-model="form.email"
        :withAgreement="true"
        @update:agreement="form.emailAgreement = $event"
        @update:pollAgreement="form.pollAgreement = $event"
      />
      <IcFormContactAddress v-model="form.address" />

      <h3>Wiadomość</h3>
      <IcFormContactMessage v-model="form.message" />

      <IcFormContactFiles v-model="form.files" />
      <IcFormAgreements v-model="form.agreement" :text="false" :header="false" :modal="true" name="agreement"  :is_visible="false" :value="true"
              :label="$t('label_agreement_checkbox')" content="form_agreement_r">
      </IcFormAgreements>

      <IcFormButtons @click="submit" :sending="isSending" :error="isError" :message="errorMessage" />
    </FormWrapper>
  </div>
</template>

<script>
import IcFormComplaintBase from "./Base/ComplaintBase";
import IcFormContactName from "./Base/Name";
import IcFormContactEmail from "./Base/Email";
import IcFormContactAddress from "./Base/Address";
import IcFormContactMessage from "./Base/Message";
import IcFormContactFiles from "./Base/Files";
import IcFormAgreements from "./Base/Agreements";
import IcFormButtons from "./Base/Buttons";
import IcInput from "@/components/ic-common/form/controls/Input";
import validations from "./Validation/r_07.js";
import { Name } from "./Model/Name";
import { Address } from "./Model/Address";
import moment from "moment";
import { emitInput } from "./Base/mixins";

export default {
  name: "IcFormComplaintR07",
  extends: IcFormComplaintBase,
  validations,

  data() {
    return {
      minDate: moment()
        .add(-1, "years")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      form: {
        
        caseNo: "",
        type: "r07",
        name: new Name(),
        emailAgreement: 0,
        address: new Address(),
        agreement: 1
      }
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcFormContactName,
    IcFormContactEmail,
    IcFormContactAddress,
    IcFormContactMessage,
    IcFormContactFiles,
    IcFormAgreements,
    IcFormButtons,
    IcInput
  }
};
</script>

<style>
</style>
